import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import Services from '../views/Services.vue';
import Users from '../views/Users.vue';
import Customers from '../views/Customers.vue';
import Notifications from '../views/Notifications.vue';
import Statistics from '../views/Statistics.vue';

Vue.use(VueRouter);

// Components definition (with lazy loading)
const routes = [
  { path: '/home', meta: { title: 'Notifiche' }, redirect: '/notifications' },
  { path: '/login', meta: { title: 'Connessione' }, name: 'login', component: Login },
  { path: '/logout', meta: { title: 'Esci' }, redirect: '/login' },

  { path: '/notifications', meta: { title: 'Notifiche' }, name: 'notifications', component: Notifications },
  { path: '/notifications/:serviceId/:period?', name: 'notifications_filtered', meta: { title: 'Notifiche', filter: true }, component: Notifications },
  { path: '/statistics', meta: { title: 'Statistiche' }, name: 'statistics', component: Statistics },
  { path: '/users', name: 'users', meta: { title: 'Utenti', filter: false }, component: Users },
  { path: '/services', name: 'services', meta: { title: 'Servizi', filter: true }, component: Services },
  { path: '/customers', name: 'customers', meta: { title: 'Clienti' }, component: Customers },

  // catch all redirect
  { path: '*', redirect: '/home' }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
